/* global Ad, setGaqPage */

export default function initLighthouseFilter(params)
{
    var searchTimer;
    var requestNumber = 0;
    var previousRequest;
    var preloadedPages = new Object();

    function triggerSearch(delayed, element)
    {
        preloadedPages = new Object();

        if(delayed == true)
        {
            if(searchTimer)
                clearTimeout(searchTimer);

            searchTimer = setTimeout(function(){delayedSearch()}, 1000);
        }
        else
            delayedSearch();
    }

    function delayedSearch(preload, direction, skipPushstate)
    {

        if(preload)
        {
            return false;
            if(preload == 'next' && $('.searchPaginationNext').length < 1)
                return;
            else if(preload == 'previous' && $('.searchPaginationPrevious').length < 1)
                return;
        }
        else
        {
            $('#searchResultsOpacity').show();
        }

        if(preload)
        {
            var currentPage = parseInt($('.searchPaginationList .active').data('page'));
            var preloadPage;

            if(preload == 'next')
                preloadPage = parseInt($('.searchPaginationNext a').data('page'));
            else if(preload == 'previous')
                preloadPage = parseInt($('.searchPaginationPrevious a').data('page'));

            if(preloadedPages[preloadPage])
                return;

            $('#formPage').val(preloadPage);
        }

        var ajaxData = Ad.Search.getSearchFormAjaxData("LighthouseSearchForm");

        if(currentPage)
            $('#formPage').val(currentPage);

        var thisRequestNumber = ++requestNumber;

        if(previousRequest)
            previousRequest.abort();

        previousRequest = $.post(params.searchAjaxUrl, ajaxData, function(data) {
            if(thisRequestNumber == requestNumber)
            {
                var loadedPage = $('#formPage').val() !== '' ? $('#formPage').val() : 1;

                if(preload)
                {
                    if(preload == 'next')
                        loadedPage++;
                    else if(preload == 'previous')
                        loadedPage--;
                }

                preloadedPages[loadedPage] = data.searchResults;

                if(!preload)
                {
                    $('.searchContent').html(data.searchResults);
                    $('.searchContent .tooltip').tooltip();
                    document.title = data.title;

                    delayedSearch(direction ? direction : 'next');

                    if (!skipPushstate) {
                        if (window.history.pushState) {
                            var pushStateUrl = data.currentUrl;

                            window.history.pushState({
                                id: (new Date).getTime(),
                                container: '#serviceContent',
                                url: pushStateUrl
                            }, pushStateUrl, pushStateUrl);
                            window.everPushedSomething = true;
                            setGaqPage();
                        }
                    }
                }
            }


        });

    }

    $(function(){

        $(window).on('scroll', function(){
            var sLoader = $('#searchResultsLoader');

            if(sLoader.length > 0)
            {
                var scrollTop = $(this).scrollTop();

                if(scrollTop < 250)
                    sLoader.css('top', '0');
                else
                    sLoader.css('top', scrollTop + 'px');
            }
        });

        Ad.Datepicker.initRange(
            "#lighthouseSearchForm_from",
            "#lighthouseSearchForm_to",
            {
                currentText: $('#currentText').data('text'),
                allowKeyboardInput: false,
            }
        );

        $("#LighthouseSearchForm").submit(function(event){
            event.preventDefault();
            triggerSearch(true);
        });

        // Submit forme za filtriranje
        $('#LighthouseSearchForm input, #LighthouseSearchForm select').change(function(){
            var self = $(this);

            var disallowSubmit = {
                'lighthouseSearchForm_from_visual' : true,
                'lighthouseSearchForm_to_visual' : true
            };

            if(disallowSubmit[self.attr('id')])
                return;

            if(self.attr('id') == 'lighthouseSearchForm_from' || self.attr('id') == 'lighthouseSearchForm_to')
            {
                if($('#lighthouseSearchForm_from').val() == '' || $('#lighthouseSearchForm_to').val() == '')
                    return;
            }

            if(self.attr('id') != 'formPage')
                $('#formPage').val('');

            var delaySearch = self.attr('id') != 'formPage' && self.attr('id') != 'formSort';

            triggerSearch(delaySearch, self);
        });

        $(document).on('click', '.searchPaginationList a', function(e){
            if(!e.ctrlKey && !e.shiftKey)
            {
                if($('#formPage').length > 0)
                {
                    e.preventDefault();
                    var page = parseInt($(this).data('page'));
                    var currentPage = parseInt($('.searchPaginationList .active').data('page'));

                    if(page != currentPage)
                    {
                        var direction = page > currentPage ? 'next' : 'previous';

                        if(previousRequest)
                            previousRequest.abort();

                        if(page == currentPage + 1)
                            delete preloadedPages[currentPage - 1];
                        else if(page == currentPage - 1)
                            delete preloadedPages[currentPage + 1];
                        else if(page == currentPage + 2)
                        {
                            delete preloadedPages[currentPage - 1];
                            delete preloadedPages[currentPage];
                        }
                        else if(page == currentPage - 2)
                        {
                            delete preloadedPages[currentPage + 1];
                            delete preloadedPages[currentPage];
                        }
                        else
                        {
                            preloadedPages = new Object();
                            direction = 'next';
                        }

                        $('#formPage').val(page);

                        if(preloadedPages[page])
                        {
                            $('#searchResultsOpacity').show();
                            $('.searchContent').html(preloadedPages[page]);
                            $('.searchContent .tooltip').tooltip();

                            delayedSearch(direction, false, true);
                        }
                        else {
                            delayedSearch(false, direction, true);
                        }

                        if (window.history.pushState) {
                            var pushStateUrl = $(this).attr('href');

                            window.history.pushState({
                                id: (new Date).getTime(),
                                container: '#serviceContent',
                                url: pushStateUrl
                            }, pushStateUrl, pushStateUrl);
                            window.everPushedSomething = true;
                        }

                        $('html, body').animate({scrollTop: 0}, 500);
                    }
                }
            }
        });

        preloadedPages[parseInt($('.searchPaginationList .active').data('page'))] = $('.searchContent').html();

        delayedSearch('next');
    });
}
